export const BloodVisionFaqs = [
  {
    // title: 'How do I choose the right ring size for me?',
    title: 'What is Blood Vision?',
    description: (
      <>
        Blood Vision, powered by UltraTrace™ technology, allows seamless
        correlation to the changes in your sleep, resting HR, HRV, and movement
        trends with pertinent markers in the blood. Decades of meticulous
        research underpin this categorisation.
        <br />
        <br /> For instance, UltraTrace™ can ascertain how a specific
        improvement in sleep quality might influence a marker like LDL,
        providing users with a probability score. This intuitive understanding
        empowers individuals to grasp the intricate connections between
        lifestyle habits and their direct impact on blood markers.
      </>
    ),
  },
  {
    // title: "I placed my ring order, what's next?",
    title: 'What do I need to know before booking a Blood Vision test?',
    description: (
      <>
        You can book your Blood Vision Test via the Ultrahuman app. All
        available test packages are visible in the app&apos;s Vision Tab. You
        can select a slot for the appointment and enter patient details
        accordingly.
        <br />
        <br /> Sample collection is available through two convenient options:
        walk-in appointments at nearby partner labs or at-home collection for
        added convenience. You can choose your preferred collection method
        during the booking process.
        <br />
        <br /> Post-collection, partial reports will start to show the same day.
        Final reports will show in the app and be shared over email once ready.
      </>
    ),
  },
  {
    // title: 'Is there any subscription fee to access ring data?',
    title: 'Is my location serviceable?',
    description: (
      <>
        Blood Vision is available in most states, but there are some
        state-specific restrictions. Customers from NY/NJ who manage to sign up
        will be informed about special procedures or extra lab fees (NY and NJ
        laws require the lab to charge an additional fee at the time of the
        draw). We advise users in those states to contact support for
        clarification. All other states (except RI) are fully supported.
      </>
    ),
  },
  {
    // title: 'Which devices qualify for the trade-in program?',
    title: 'What are the different tests available?',
    description: (
      <>
        Blood Vision offers a comprehensive set of over 120 biomarkers through
        our annual plan. These include tests across key categories such as
        metabolic health, hormonal balance, inflammation, cardiovascular risk,
        vitamin and mineral levels, thyroid function, and more. The specific
        panels are curated based on biological sex and health goals, and you can
        also choose additional specialized add-ons during onboarding.
      </>
    ),
  },
  {
    // title: 'In what colours is the ring available?',
    title: 'Can I see a sample report for my test?',
    description: (
      <>
        Yes! Just open the Ultrahuman app {'>'} Vision tab {'>'} Toggle on
        &quot;Visualise Sample Report&quot;
      </>
    ),
  },
  {
    title: 'How long do the reports take?',
    description: (
      <>
        Once the samples are collected, partial reports start showing up within
        6 hours. Depending on the extent of your test, final reports can take up
        to 21 days, although they may sometimes be available sooner.
      </>
    ),
  },
  {
    title: 'Can I reschedule my appointment?',
    description: (
      <>
        Yes! Just head to the Ultrahuman app {'>'} Profile {'>'} Blood Vision{' '}
        {'>'} Test {'>'} Reschedule.
      </>
    ),
  },
  {
    title: 'Will the tests be refunded by my insurance providers?',
    description: (
      <>
        You will need to check with your insurance provider for this. Blood
        Vision is a direct-pay service and does not bill your insurance
        provider. However, you can pay using HSA/FSA cards since our tests
        qualify as preventive health expenses. While we don&apos;t provide CPT
        codes or diagnosis details needed for insurance reimbursement, you can
        try submitting our itemized receipt to your insurer for potential
        out-of-network reimbursement. Just keep in mind that coverage is not
        guaranteed.
      </>
    ),
  },
];
